"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
class Player {
    constructor(user, monkey, monkeyHealth) {
        this.potassium = 0;
        this.deck = [];
        this.hand = [];
        this.board = [];
        this.dead = [];
        this.pickCards = [];
        this.cardsPicked = false;
        this.ready = false;
        this.fatigue = 0;
        this.user = user;
        this.monkey = monkey;
        this.monkeyHealth = monkeyHealth;
    }
}
exports.Player = Player;
